/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './graphqlSchema';

export type ContentSummaryFieldsFragment = { id: string, state: string, date: string | null, title: string, byline: string | null, contentType: Types.ContentTypeEnum | null, region: { code: string }, image: { src: string, alt: string, placeholderColor: string, crop: { type: Types.CropEnum, height: number, width: number, x: number, y: number } | null, crops: Array<{ type: Types.CropEnum, height: number, width: number, x: number, y: number }> } | null };

export type SearchQueryVariables = Exact<{
  query: string;
  regionCode?: string | null | undefined;
}>;


export type SearchQuery = { search: Array<{ id: string, state: string, date: string | null, title: string, byline: string | null, contentType: Types.ContentTypeEnum | null, region: { code: string }, image: { src: string, alt: string, placeholderColor: string, crop: { type: Types.CropEnum, height: number, width: number, x: number, y: number } | null, crops: Array<{ type: Types.CropEnum, height: number, width: number, x: number, y: number }> } | null }> | null };

export type UnplacedContentQueryVariables = Exact<{
  regionCode: string;
  slug: string;
}>;


export type UnplacedContentQuery = { unplacedContent: Array<{ id: string, state: string, date: string | null, title: string, byline: string | null, contentType: Types.ContentTypeEnum | null, region: { code: string }, image: { src: string, alt: string, placeholderColor: string, crop: { type: Types.CropEnum, height: number, width: number, x: number, y: number } | null, crops: Array<{ type: Types.CropEnum, height: number, width: number, x: number, y: number }> } | null }> | null };

export type CommonDataQueryQueryVariables = Exact<{
  regionCode: string;
}>;


export type CommonDataQueryQuery = { navItems: Array<{ title: string, position: number, path: string }>, activeRegions: Array<{ code: string, nameInRegionLanguage: string }> };

export type EventsQueryVariables = Exact<{
  regionCode: string;
}>;


export type EventsQuery = { events: Array<{ id: string, name: string, trackingUrl: string, byline: string, imageSrc: string | null }> };

export type InfographicQueryVariables = Exact<{
  id: string | number;
}>;


export type InfographicQuery = { infographic: { id: string, src: string, title: string } | null };

export type InfographicSearchQueryVariables = Exact<{
  query: string;
}>;


export type InfographicSearchQuery = { infographicSearch: Array<{ id: string, title: string, createdAt: string | null }> | null };

export type MostReadQueryVariables = Exact<{
  regionCode?: string | null | undefined;
  filterByCommissioningRegion?: boolean | null | undefined;
  languageCode?: string | null | undefined;
  pageSlug?: string | null | undefined;
}>;


export type MostReadQuery = { mostRead: Array<{ id: string, title: string, byline: string | null, url: string, image: { src: string, placeholderColor: string, crops: Array<{ type: Types.CropEnum, width: number, height: number, x: number, y: number }> } | null }> };

export type MostReadInspectorQueryVariables = Exact<{
  regionCode: string;
}>;


export type MostReadInspectorQuery = { languages: Array<{ code: string, label: string }>, routes: Array<{ id: string, slug: string, region: { code: string } }> | null, navItems: Array<{ path: string, title: string }> };

export type PartnersQueryVariables = Exact<{
  regionCode: string;
  pageSlug: string;
}>;


export type PartnersQuery = { partners: Array<{ name: string, path: string, logoUrl: string, type: string }> | null };

export type PageHistoryQueryVariables = Exact<{
  regionCode: string;
  pageSlug: string;
  currentPage: number;
}>;


export type PageHistoryQuery = { history: { nextPage: number | null, previousPage: number | null, items: Array<{ id: string, createdAt: any, author: { name: string }, route: { id: string } }> } | null };

export type LexicalPageQueryVariables = Exact<{
  regionCode: string;
  pageSlug: string;
}>;


export type LexicalPageQuery = { draftPage: { id: string, schemaVersion: number, updatedAt: any, pageType: Types.PageTypeEnum, doc: { meta: any, blocks: Array<
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { analyticsId: string | null, href: string, title: string, text: string, style: Types.CallToActionStyle, type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { slotSizes: Array<Types.GridSlotSize>, slotTypes: Array<Types.GridSlot>, type: Types.BlockEnum, props: any, blocks: Array<
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum, id: string, url: string, title: string, customTitle: string | null, byline: string | null, contentType: Types.ContentTypeEnum | null, hideByline: boolean | null, tagStyle: Types.TagStyle | null, tagLabel: string | null, image: { src: string, alt: string, placeholderColor: string, paletteData: { averageLuminance: number }, crops: Array<{ type: Types.CropEnum, width: number, height: number, x: number, y: number }> } | null }
            | { type: Types.BlockEnum, props: any, title: string, href: string, byline: string | null, tagLabel: string | null, tagStyle: Types.TagStyle | null, imageAlt: string, image: { id: string, src: string, alt: string, placeholderColor: string, paletteData: { averageLuminance: number }, crops: Array<{ type: Types.CropEnum, width: number, height: number, x: number, y: number }> } | null }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
          > }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, regionCode: string, filterByCommissioningRegion: boolean, language: string, pageSlug: string, props: any, contentSummaries: Array<{ id: string, title: string, byline: string | null, url: string, image: { src: string, placeholderColor: string, paletteData: { averageLuminance: number }, crops: Array<{ type: Types.CropEnum, width: number, height: number, x: number, y: number }> } | null }> }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, explainer: string, partnerLinkDescription: string, props: any, partners: Array<{ name: string, logoUrl: string, path: string, type: string }> }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
      > }, route: { id: string, slug: string, region: { code: string } } } | null };

export type NewslettersPageQueryVariables = Exact<{
  regionCode: string;
}>;


export type NewslettersPageQuery = { newslettersPage: { cacheKey: string, groups: Array<{ name: string, groupItems: Array<{ id: string, name: string, promoted: boolean, frequency: string, description: string, pitch: string, previewUrl: string | null, heroImageUrl: string, thumbnailImageUrl: string }> }> } | null };

export type ViewPageQueryVariables = Exact<{
  regionCode: string;
  pageSlug: string;
}>;


export type ViewPageQuery = { currentPage: { cacheKey: string, pageType: Types.PageTypeEnum, doc: { meta: any, blocks: Array<
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { analyticsId: string | null, href: string, title: string, text: string, style: Types.CallToActionStyle, type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any, events: Array<{ id: string, name: string, byline: string, imageSrc: string | null, trackingUrl: string }> }
        | { slotSizes: Array<Types.GridSlotSize>, slotTypes: Array<Types.GridSlot>, type: Types.BlockEnum, props: any, blocks: Array<
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum, id: string, url: string, tagStyle: Types.TagStyle | null, tagLabel: string | null, title: string, customTitle: string | null, byline: string | null, contentType: Types.ContentTypeEnum | null, hideByline: boolean | null, image: { src: string, alt: string, placeholderColor: string, paletteData: { averageLuminance: number }, crops: Array<{ type: Types.CropEnum, width: number, height: number, x: number, y: number }> } | null }
            | { type: Types.BlockEnum, props: any, title: string, href: string, byline: string | null, tagLabel: string | null, tagStyle: Types.TagStyle | null, imageAlt: string, image: { id: string, src: string, alt: string, placeholderColor: string, paletteData: { averageLuminance: number }, crops: Array<{ type: Types.CropEnum, width: number, height: number, x: number, y: number }> } | null }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
            | { type: Types.BlockEnum }
          > }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any, contentSummaries: Array<{ id: string, title: string, byline: string | null, url: string, image: { src: string, placeholderColor: string, paletteData: { averageLuminance: number }, crops: Array<{ type: Types.CropEnum, width: number, height: number, x: number, y: number }> } | null }> }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, explainer: string, partnerLinkDescription: string, props: any, partners: Array<{ name: string, logoUrl: string, path: string, type: string }> }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
        | { type: Types.BlockEnum, props: any }
      > } } | null };

export * from './graphqlSchema';